$( document ).ready(function() {

    if (window.location.pathname != "/shop")
    {
        return;
    }

	var discountPercent = 0;
	var discountValue = 0;
	var discountCode = "";

	var currentTotal = 0;

	var finalTotal = 0;

	var maximalInCart = false;
	var complexerInCart = false;
	var pivotInCart = false;
	var deeqInCart = false;
    var lowtilityInCart = false;
    var phraseboxInCart = false;

	var maximalPrice = parseInt($('#maximal-shop-object p:first').html().replace("£", ""));
	var complexerPrice = parseInt($('#complexer-shop-object p:first').html().replace("£", ""));
	var pivotPrice = parseInt($('#pivot-shop-object p:first').html().replace("£", ""));
	var deeqPrice = parseInt($('#deeq-shop-object p:first').html().replace("£", ""));
    var lowtilityPrice = parseInt($('#lowtility-shop-object p:first').html().replace("£", ""));
    var phraseboxPrice = parseInt($('#phrasebox-shop-object p:first').html().replace("£", ""));

	/** Update the cart price applying the coupon */
	function updateCouponPrice()
	{
		discountValue = currentTotal * discountPercent / 100.0;
		finalTotal = currentTotal - discountValue;

	//	console.log("--------------")
	//	console.log("£"+currentTotal);
	//	console.log(discountPercent + "%")
	//	console.log("£"+discountValue);
	//	console.log("£"+finalTotal);
	}


	/** Confirm the coupon is valid and apply to the cart */
//	function applyCoupon()
//	{
//		discountCode = $('#coupon-input').val();
//		discountPercent = $('#coupon-input').val();
//		updateCart();
//	}


	updateCart();

	/** Updates the cart with the selected product and shows or hides in the sidebar */
	function updateCart()
	{
		var htmlOut = "";
		currentTotal = 0;

		if (maximalInCart == true)
		{
			htmlOut += "<p class='pull-right'>£"+maximalPrice.toFixed(2)+"</p><p>Maximal 3</p>";
			currentTotal += maximalPrice;
		}

		if (complexerInCart == true)
		{
			htmlOut += "<p class='pull-right'>£"+complexerPrice.toFixed(2)+"</p><p>Complexer 2</p>";
			currentTotal += complexerPrice;
		}

		if (pivotInCart == true)
		{
			htmlOut += "<p class='pull-right'>£"+pivotPrice.toFixed(2)+"</p><p>Pivot</p>";
			currentTotal += pivotPrice;
		}
		if (deeqInCart == true)
		{
			htmlOut += "<p class='pull-right'>£"+deeqPrice.toFixed(2)+"</p><p>DeeQ</p>";
			currentTotal += deeqPrice;
		}
		if (lowtilityInCart == true)
		{
			htmlOut += "<p class='pull-right'>£"+lowtilityPrice.toFixed(2)+"</p><p>Lowtility 2</p>";
			currentTotal += lowtilityPrice;
        }
        if (phraseboxInCart == true)
		{
			htmlOut += "<p class='pull-right'>£"+phraseboxPrice.toFixed(2)+"</p><p>Phrasebox</p>";
			currentTotal += phraseboxPrice;
		}


		updateCouponPrice();

		if (discountPercent > 0 && currentTotal > 0)
		{
			htmlOut += "<p class='pull-right'>-£"+discountValue.toFixed(2)+"</p><p>Coupon Discount</p>";
		}

		if (htmlOut != "")
		{
			htmlOut += "<hr>";

			htmlOut += "<p class='pull-right'>£" + finalTotal.toFixed(2) + "</p><p>Total</p>";
			htmlOut += "<button id='checkout-button' class='v2-button btn-block'>Checkout</button>";

			htmlOut += "<hr></hr>";

			htmlOut += 	"<div id='coupon-div'>";


			if (discountPercent > 0)
			{
				htmlOut += 	"<p>Coupon Code <b>"+discountCode+"</b> (-"+discountPercent+"%)</p>";
				htmlOut += 	"<a href='#' id='coupon-clear'>Remove Coupon</a>";
			}
			else
			{
				htmlOut += 	"<a href='#' id='coupon-toggle'>Enter Coupon Code</a>";
			}

			htmlOut += 		"<div id='coupon-form-div'  style='display: none'>";
			htmlOut += 			"<input type='text' class='form-control' id='coupon-input'>";
			htmlOut += 			"<button id='coupon-submit-button' class='v2-button btn-block'>Apply Coupon</button>";
			htmlOut += 			"<div style='display: none;' id='coupon-error' class='alert alert-danger'></div>";
			htmlOut += 		"<div>";
			htmlOut += 	"<div>";
		}
		else
		{
			htmlOut = "Nothing in Cart";
		}

		$('#cart-contents').html(htmlOut);
	}




	/** When the "I have a coupon" link is clicked */
	$(document).on('click', '#coupon-toggle', function(e)
	{
		$('#coupon-toggle').hide();
		$('#coupon-form-div').show();
	});


	/** When the "Apply coupon" button is clicked */
	$(document).on('click', '#coupon-submit-button', function(e)
	{
		e.preventDefault();
		$('#coupon-error').hide();
		$.ajax({
			url: '/get-discount',
			type: 'post',
			data: "discount_id="+$('#coupon-input').val(),
			success: function (response)
			{
				//window.location.href = response;
			//	console.log(response);
				discountCode = response.code;
				discountPercent = response.percent;
				updateCart();
			},
			error: function (response)
			{
			//	console.log(response);
				$('#coupon-error').html(response.responseJSON);
				$('#coupon-error').show();
			},
		});
	});

	$(document).on('click', '#coupon-clear', function(e)
	{
		discountPercent = 0;
		discountValue = 0;
		discountCode = "";
		updateCart();
	});



	$('#maximal-shop-object').on('click', function(e)
	{
		if(!$(this).hasClass("shop-selected")){
			$(this).addClass("shop-selected");
			$('#complexer-shop-object').removeClass("shop-selected");
			$('#pivot-shop-object').removeClass("shop-selected");
			$('#deeq-shop-object').removeClass("shop-selected");
            $('#lowtility-shop-object').removeClass("shop-selected");
            $('#phrasebox-shop-object').removeClass("shop-selected");
			maximalInCart = true;
			complexerInCart = false;
			pivotInCart = false;
			deeqInCart = false;
            lowtilityInCart = false;
            phraseboxInCart = false;
		}
		else
		{
			$(this).removeClass("shop-selected");
			maximalInCart = false;
		}
		updateCart();
	});

	$('#complexer-shop-object').on('click', function(e)
	{
		if(!$(this).hasClass("shop-selected")){
			$(this).addClass("shop-selected");
			complexerInCart = true;
			maximalInCart = false;
			pivotInCart = false;
			deeqInCart = false;
            lowtilityInCart = false;
            phraseboxInCart = false;
			$('#maximal-shop-object').removeClass("shop-selected");
			$('#pivot-shop-object').removeClass("shop-selected");
			$('#deeq-shop-object').removeClass("shop-selected");
            $('#lowtility-shop-object').removeClass("shop-selected");
            $('#phrasebox-shop-object').removeClass("shop-selected");
		}
		else
		{
			$(this).removeClass("shop-selected");
			complexerInCart = false;
		}
		updateCart();
	});

	$('#pivot-shop-object').on('click', function(e)
	{
		if(!$(this).hasClass("shop-selected")){
			$(this).addClass("shop-selected");
			complexerInCart = false;
			maximalInCart = false;
			pivotInCart = true;
			deeqInCart = false;
            lowtilityInCart = false;
            phraseboxInCart = false;
			$('#maximal-shop-object').removeClass("shop-selected");
			$('#complexer-shop-object').removeClass("shop-selected");
			$('#deeq-shop-object').removeClass("shop-selected");
            $('#lowtility-shop-object').removeClass("shop-selected");
            $('#phrasebox-shop-object').removeClass("shop-selected");
		}
		else
		{
			$(this).removeClass("shop-selected");
			pivotInCart = false;
		}
		updateCart();
	});

	$('#deeq-shop-object').on('click', function(e)
	{
		if(!$(this).hasClass("shop-selected")){
			$(this).addClass("shop-selected");
			complexerInCart = false;
			maximalInCart = false;
			pivotInCart = false;
			deeqInCart = true;
            lowtilityInCart = false;
            phraseboxInCart = false;
			$('#maximal-shop-object').removeClass("shop-selected");
			$('#complexer-shop-object').removeClass("shop-selected");
			$('#pivot-shop-object').removeClass("shop-selected");
            $('#lowtility-shop-object').removeClass("shop-selected");
            $('#phrasebox-shop-object').removeClass("shop-selected");
		}
		else
		{
			$(this).removeClass("shop-selected");
			deeqInCart = false;
		}
		updateCart();
	});
	$('#lowtility-shop-object').on('click', function(e)
	{
		if(!$(this).hasClass("shop-selected")){
			$(this).addClass("shop-selected");
			complexerInCart = false;
			maximalInCart = false;
			pivotInCart = false;
			deeqInCart = false;
            lowtilityInCart = true;
            phraseboxInCart = false;
			$('#maximal-shop-object').removeClass("shop-selected");
			$('#complexer-shop-object').removeClass("shop-selected");
			$('#pivot-shop-object').removeClass("shop-selected");
            $('#deeq-shop-object').removeClass("shop-selected");
            $('#phrasebox-shop-object').removeClass("shop-selected");
		}
		else
		{
			$(this).removeClass("shop-selected");
			lowtilityInCart = false;
		}
		updateCart();
    });
    $('#phrasebox-shop-object').on('click', function(e)
	{
		if(!$(this).hasClass("shop-selected")){
			$(this).addClass("shop-selected");
			complexerInCart = false;
			maximalInCart = false;
			pivotInCart = false;
			deeqInCart = false;
            lowtilityInCart = false;
            phraseboxInCart = true;
			$('#maximal-shop-object').removeClass("shop-selected");
			$('#complexer-shop-object').removeClass("shop-selected");
			$('#pivot-shop-object').removeClass("shop-selected");
            $('#deeq-shop-object').removeClass("shop-selected");
            $('#lowtility-shop-object').removeClass("shop-selected");
		}
		else
		{
			$(this).removeClass("shop-selected");
			phraseboxInCart = false;
		}
		updateCart();
	});


		$('body').on('click', '#checkout-button', function(e)
		{
			var productName = "Maximal 3";
			if (complexerInCart)
				productName = "Complexer 2";
			if (pivotInCart)
				productName = "Pivot";
			if (deeqInCart)
				productName = "DeeQ";
			if (lowtilityInCart)
                productName = "Lowtility 2";
            if (phraseboxInCart)
				productName = "Phrasebox";
			e.preventDefault();
			hideBuyButton();
			$.ajax({
				url: '/user/buy-link',
				type: 'post',
				data: "product="+productName+"&coupon="+discountCode+"&total="+finalTotal,
				success: function (response)
				{
					if (typeof fbq === 'function')
						fbq('track', 'InitiateCheckout');

					window.location.href = response;
				},
				error: function (response)
				{
					showBuyButton();
					if (response.status == 401)
						$('#shop-register-error').show();
					else
						alert(response.responseText);
				},
			});
		});


		function hideBuyButton()
		{
			$('#checkout-button').text("").html("<i class='fas fa-circle-notch fa-spin fa-fw'></i>");
		}
		function showBuyButton()
		{
			$('#checkout-button').text("").html("Checkout");
		}


});
